<template>
    <v-container>
        <loader v-if="isloading"></loader>

        <v-row>
            <v-col cols="12">
                <v-toolbar flat color="#1d2735" dark style="border-radius: 5px">
                    <v-icon class="white--text" style="font-size: 45px"
                        >mdi-account-supervisor-circle</v-icon
                    >
                    <pre><v-toolbar-title><h2>Comprobar la viabilidad</h2></v-toolbar-title></pre>
                </v-toolbar>

                <v-form ref="form" class="mt-3">
                    <v-row>
                        <v-col cols="12">
                            <router-link to="lista-presupuesto"> </router-link>
                        </v-col>
                    </v-row>
                    <h2>Datos de presupuesto</h2>
                    <v-row justify="end">
                        <v-col
                            cols="12"
                            md="4"
                            v-if="presupuesto.cliente.length > 0"
                        >
                            <v-text-field
                                readonly
                                v-model="presupuesto.cliente[0].nombre"
                                @update:search-input="SearchCliente"
                                :items="clientes"
                                item-text="codnombre"
                                item-value="id"
                                label="Cliente"
                                :rules="required_val"
                            >
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" md="4">
                            <date-select
                                readonly
                                v-model="presupuesto.fecha"
                                label="Fecha"
                                :rules="required_val"
                            >
                            </date-select>
                        </v-col>

                        <!--v-col-- cols="12" md="6" >
                                        <div style="display: flex">
                                            <v-autocomplete
                                                v-model="
                                                    presupuesto.id_sociedad
                                                "
                                                :rules="required_val"
                                                label="Sociedad"
                                                :items="sociedades"
                                                item-text="nombre"
                                                item-value="id"
                                            >
                                            </v-autocomplete>
                                        </div>
                                    </!--v-col-->
                    </v-row>

                    <v-row>
                        <template v-for="producto in productos">
                            <v-col
                                v-if="
                                    presupuesto.lineas.filter(
                                        (element) =>
                                            element.id_producto == producto.id
                                    ).length > 0
                                "
                                cols="12"
                                :key="producto.id"
                            >
                                <template>
                                    <h5>{{ producto.nombre }}</h5>
                                    <v-data-table
                                        dense
                                        :headers="headers"
                                        hide-default-footer
                                        :items="
                                            presupuesto.lineas.filter(
                                                (element) =>
                                                    element.id_producto ==
                                                    producto.id
                                            )
                                        "
                                        item-key="id"
                                        class="elevation-1"
                                    >
                                        <template
                                            v-slot:item.producto="{ item }"
                                        >
                                            <p style="white-space: pre-line">
                                                {{ item.descripcion }}
                                            </p>
                                        </template>
                                        <template v-slot:item.pvp="{ item }">
                                            {{
                                                razonChiguire(
                                                    item.cantidad * item.precio
                                                ) | format_precio
                                            }}
                                        </template>

                                        <template
                                            v-slot:item.dcto_unidad="{ item }"
                                        >
                                            {{
                                                razonChiguire(
                                                    item.dcto / item.cantidad
                                                ) | format_precio
                                            }}
                                        </template>
                                        <template
                                            v-slot:item.cantidad="{ item }"
                                        >
                                            {{ item.cantidad | decimalComma }}
                                        </template>
                                        <template v-slot:item.precio="{ item }">
                                            {{
                                                razonChiguire(item.precio)
                                                    | format_precio
                                            }}
                                        </template>
                                        <template v-slot:item.dcto="{ item }">
                                            {{
                                                razonChiguire(item.dcto)
                                                    | format_precio
                                            }}
                                        </template>
                                        <template v-slot:item.total="{ item }">
                                            {{
                                                razonChiguire(item.total)
                                                    | format_precio
                                            }}
                                        </template>
                                        <template
                                            v-slot:item.dcto_total="{ item }"
                                        >
                                            {{
                                                razonChiguire(
                                                    CalcularTotalDcto(item)
                                                ) | format_precio
                                            }}
                                        </template>
                                        <template v-slot:item.action="{ item }">
                                            <v-icon
                                                @click="openEditDialog(item)"
                                                small
                                                class="mr-2"
                                                color="black"
                                                style="font-size: 25px"
                                                title="EDITAR"
                                                >mdi-pencil-outline</v-icon
                                            >

                                            <v-icon
                                                @click="openDeleteDialog(item)"
                                                small
                                                class="mr-2"
                                                color="red"
                                                style="font-size: 25px"
                                                title="BORRAR"
                                                >mdi-trash-can</v-icon
                                            >
                                        </template>
                                    </v-data-table>
                                    <v-card style="margin-top: 3rem">
                                        <v-row>
                                            <v-col cols="6">
                                                <h4>
                                                    Subtotal:

                                                    {{
                                                        formatNumber(
                                                            razonChiguire(
                                                                CalcularSubTotales(
                                                                    presupuesto.lineas.filter(
                                                                        (
                                                                            element
                                                                        ) =>
                                                                            element.id_producto ==
                                                                            producto.id
                                                                    )
                                                                )
                                                            )
                                                        )
                                                    }}
                                                    €
                                                </h4>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </template>
                            </v-col>
                        </template>
                    </v-row>
                    <v-row align="start" justify="end">
                        <v-col cols="12" md="8">
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field-comma
                                        readonly
                                        v-model="presupuesto.mudanza"
                                        type="number"
                                        label="Plataforma de mudanza"
                                    >
                                    </v-text-field-comma>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div style="display: flex">
                                        <v-text-field-comma
                                            readonly
                                            v-model="presupuesto.dcto"
                                            type="number"
                                            label="Descuento"
                                            :suffix="
                                                presupuesto.id_tipo_dcto == 1
                                                    ? '%'
                                                    : '€'
                                            "
                                        >
                                        </v-text-field-comma>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div style="display: flex">
                                        <v-autocomplete
                                            v-model="presupuesto.iva"
                                            type="text"
                                            label="IVA"
                                            :items="ivas"
                                            suffix="%"
                                        >
                                        </v-autocomplete>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-card style="min-width: 100%; padding: 1rem">
                                <v-row>
                                    <v-col cols="6">
                                        <h4>Subtotal:</h4>
                                    </v-col>
                                    <v-col cols="6">
                                        <h4>
                                            {{
                                                formatNumber(
                                                    razonChiguire(
                                                        calcularSubTotal()
                                                    )
                                                )
                                            }}
                                            €
                                        </h4>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <h4>Descuento:</h4>
                                    </v-col>
                                    <v-col cols="6">
                                        <h4>
                                            -
                                            {{
                                                formatNumber(
                                                    razonChiguire(
                                                        CalculateDescuento(
                                                            presupuesto.subtotal
                                                        )
                                                    )
                                                )
                                            }}
                                            €
                                        </h4>
                                    </v-col>
                                </v-row>
                                <v-row v-if="presupuesto.iva != 0">
                                    <v-col cols="6">
                                        <h4>IVA:</h4>
                                    </v-col>
                                    <v-col cols="6">
                                        <h4>
                                            {{
                                                formatNumber(
                                                    razonChiguire(
                                                        calcularSubTotal() -
                                                            this.CalculateDescuento()
                                                    ) *
                                                        (Number.parseFloat(
                                                            presupuesto.iva.toString()
                                                        ) /
                                                            100)
                                                )
                                            }}
                                            €
                                        </h4>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <h4>Total:</h4>
                                    </v-col>
                                    <v-col cols="6">
                                        <h4>
                                            {{
                                                formatNumber(
                                                    razonChiguire(
                                                        presupuesto.total
                                                    )
                                                )
                                            }}
                                            €
                                        </h4>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-card>
                        <v-row>
                            <v-col cols="6">
                                <h4>Total:</h4>
                            </v-col>
                            <v-col cols="6">
                                <h4
                                    :style="
                                        totalMetodoPago != 100
                                            ? 'color:red'
                                            : ''
                                    "
                                >
                                    {{ formatNumber(totalMetodoPago) }}
                                    %
                                </h4>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-row>
                        <v-col cols="12">
                            <v-textarea
                                readonly
                                v-model="presupuesto.observaciones"
                                label="Obersevaciones"
                                outlined
                            >
                            </v-textarea> </v-col
                    ></v-row>
                </v-form>
                <v-row>
                    <v-col cols="12">
                        <h3>Archivos del presupuesto</h3>
                    </v-col>
                </v-row>
                <listaArchivos
                    :readonly="true"
                    v-on:delete_archivo="deleteArchivo"
                    :items="presupuesto.archivo"
                    @subir_file="subirArchivo"
                    @subir_file_64="subirArchivo64"
                ></listaArchivos>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { debounce } from "../../../../helpers";
import listaArchivos from "../../../../components/general/listaArchivos.vue";
import Dibujar from "./../Dibujar.vue";
export default {
    components: {
        listaArchivos,
        Dibujar,
    },
    data() {
        return {
            imagen: null,
            email_descripcion: "",
            metodo: {},
            metodos_pago: [],
            headers_metodos: [
                { text: "Método", value: "metodo.nombre", sortable: false },
                { text: "Porcentaje (%)", value: "monto", sortable: false },
            ],
            descripcion_email: null,
            product_dialog: false,
            required_val: [
                (v) => !!v || "El campo es requerido",
                (v) => v != "" || "El campo es requerido",
            ],
            required_val_0: [
                (v) => !!v || "El campo es requerido",
                (v) => v != "" || "El campo es requerido",
                (v) => v != 0 || "El campo no puede ser 0",
            ],
            sociedades: [],
            estados: [],
            ivas: [21, 10, 4],
            email_dialog: false,
            email: "",
            rol: 0,
            headers: [
                { text: "Título", value: "titulo", sortable: false },
                {
                    text: "Denominación",
                    value: "denominacion",
                    sortable: false,
                },
                { text: "Descripción", value: "producto", sortable: false },
                { text: "Unidades", value: "cantidad", sortable: false },
                { text: "Precio/Unidad", value: "precio", sortable: false },
                { text: "Subtotal", value: "pvp", sortable: false },

                {
                    text: "Descuento",
                    value: "dcto_total",
                    sortable: false,
                },
                { text: "Total", value: "total", sortable: false },
            ],
            enable_iva: false,

            productos: [],

            presupuesto: {
                mudanza: 0,
                mostar_financiacion: 0,
                id_estado: 1,
                id: null,
                fecha: new Date(
                    Date.now() - new Date().getTimezoneOffset() * 60000
                )
                    .toISOString()
                    .substr(0, 10),
                revisado: false,
                metodos_pago: [],
                id: null,
                id_cliente: null,
                iva: 21,
                subtotal: 0,

                dcto: 0,
                id_tipo_dcto: 0,
                total: 0,
                lineas: [],
                lineas_deleted: [],
            },
            delete_dialog: false,
            linea: {
                id: null,
                dcto_total: 0,
                id_producto: null,
                producto: "",
                cantidad: 0,
                precio: 0,
                id_tipo_dcto: 0,
                dcto: 0,
                total: 0,
                tipo_prod: 0,
            },
            editlinea: {
                id_producto: null,
                producto: "",
                dcto_total: 0,
                cantidad: 0,
                precio: 0,
                id_tipo_dcto: 0,
                dcto: 0,
                total: 0,
                tipo_prod: 0,
            },
            dialog: false,
            init_edit: false,
            edit_index: -1,
            descripciones_pdf: [],
            descripcion_pdf: { id: null, descripcion: null },
        };
    },
    watch: {
        imagen: function (val) {
            let file = document.getElementById("imagen").files[0];
            if (file != null) {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                let esto = this;
                reader.onload = function () {
                    let elemento = reader.result.split(",")[1];
                    //console.log(elemento);
                    esto.presupuesto.imagen_pdf = elemento;
                };
                reader.onerror = function (error) {
                    //console.log("Error: ", error);
                };
            }
        },
        descripcion_email: function (val) {
            this.email_descripcion = this.descripciones_pdf.find(
                (element) => element.id == this.descripcion_email
            ).descripcion;
        },
        enable_iva: function (val) {
            if (!val) {
                this.presupuesto.iva = 0;
            }

            this.calcularTotalmax();
        },

        "presupuesto.iva": function (iva) {
            this.calcularTotalmax();
        },
        "presupuesto.id_tipo_dcto": function () {
            this.calcularTotalmax();
        },
        "presupuesto.dcto": function () {
            this.calcularTotalmax();
        },
        "presupuesto.mudanza": function (val) {
            this.calcularTotalmax();
        },
        "linea.id_producto": function (val) {
            this.productos.forEach((element) => {
                if (element.id == val) {
                    this.linea.producto = element.nombre.toString();
                    this.linea.precio = element.precio;
                }
            });
        },
        "editlinea.id_producto": function (val) {
            this.productos.forEach((element) => {
                if ((element.id == val) & !this.init_edit) {
                    this.editlinea.producto = element.nombre.toString();
                    this.editlinea.precio = element.precio;
                }
                this.init_edit = false;
            });
        },
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
        nacimiento(val) {
            this.nacimientoesp = this.formatDate(this.nacimiento);
            this.cliente.nacimiento = this.nacimiento;
        },
        fecha_alta(val) {
            /*this.fecha_altaesp = this.formatDate(this.fecha_alta);
            this.cliente.fecha_alta = this.fecha_alta;*/
        },
    },
    created() {
        this.rol = localStorage.getItem("role");
        this.getMetodosPago();
        this.getDescripcionesPdf();
        this.getSociedades();
        this.getProductos();
        this.getEstados();
        if (this.$route.query.id) {
            this.getPresupuesto(this.$route.query.id);
        } else {
            if (this.$route.query.cliente) {
                this.presupuesto.id_cliente = parseInt(
                    this.$route.query.cliente
                );
            }
            this.$store.dispatch("getClientes", this);
        }
    },
    methods: {
        generarOrdenes() {
            if (this.presupuesto.id) {
                axios
                    .post("api/ordenes-from-presupuesto", {
                        id: this.presupuesto.id,
                    })
                    .then((res) => {
                        this.$custom_success("Órdenes generadas con éxito");
                    });
            }
        },
        CalcularSubTotales(lineas) {
            //console.log(lineas);
            let total = 0;
            lineas.forEach((element) => {
                total += parseFloat(element.total);
            });
            if (!isNaN(parseFloat(this.presupuesto.mudanza))) {
                total += parseFloat(this.presupuesto.mudanza);
            }

            return total;
        },
        subirArchivo64(data, nombre, clear, extension) {
            let me = this;
            axios
                .post(`api/save-archivo64-presupuesto`, {
                    id: this.presupuesto.id,
                    archivo: data,
                    nombre: nombre,
                    extension: extension,
                })
                .then((res) => {
                    me.presupuesto.archivo = res.data;
                    this.$toast.sucs("Archivo guardado con éxito");
                    clear();
                });
        },
        subirArchivo(archivo) {
            let me = this;
            archivo.append("id", this.presupuesto.id);
            axios.post(`api/save-archivo-presupuesto`, archivo).then((res) => {
                me.presupuesto.archivo = res.data;
            });
        },
        deleteArchivo(archivo) {
            axios.get(`api/deletearchivo-presupuesto/${archivo.id}`).then(
                (res) => {
                    this.presupuesto.archivo = res.data;
                },
                (res) => {
                    this.$toast.error("Error al eliminar el archivo");
                }
            );
        },
        updateAgentesS(index) {
            //console.log(index);
            this.metodo = JSON.parse(
                JSON.stringify(this.presupuesto.metodos_pago[index])
            );
            this.index = index;
        },

        //metodos
        deleteAgentes(indexo) {
            this.presupuesto.metodos_pago.splice(indexo, 1);
        },
        createAgente() {
            //console.log(this.metodo.id_metodo);

            this.presupuesto.metodos_pago.push({
                id: null,
                id_metodo: this.metodo.id_metodo,
                monto: this.metodo.monto,
                metodo: JSON.parse(
                    JSON.stringify(
                        this.metodos_pago.find(
                            (element) => element.id == this.metodo.id_metodo
                        )
                    )
                ),
            });
            //console.log(this.presupuesto.metodos_pago);
            this.metodo = {};
        },

        updateAgentes() {
            this.presupuesto.metodos_pago[this.index].id_metodo =
                this.metodo.id_metodo;
            this.presupuesto.metodos_pago[this.index].monto = this.metodo.monto;

            (this.presupuesto.metodos_pago[this.index].metodo = JSON.parse(
                JSON.stringify(
                    this.metodos_pago.find(
                        (element) => element.id == this.metodo.id_metodo
                    )
                )
            )),
                (this.metodo = {});
        },
        getEstados() {
            axios.get("api/get-estados-presupuestos").then((res) => {
                this.estados = res.data;
            });
        },
        getMetodosPago() {
            axios.get("api/metodos-de-pago").then((res) => {
                this.metodos_pago = res.data.metodos;
            });
        },
        getDescripcionesPdf() {
            axios.get("api/get-descripciones-pdf").then((res) => {
                this.descripciones_pdf = res.data;
            });
        },
        openEditPDFDialog(id) {
            this.descripcion_pdf = this.descripciones_pdf.find(
                (element) => element.id == id
            );
        },
        selectDescripcion(id) {
            this.descripcion_pdf = this.descripciones_pdf.find(
                (element) => element.id == id
            );
            if (this.descripcion_pdf == null) {
                this.descripcion_pdf = { id: null, descripcion: null };
            }
        },
        saveDescripcionesPdf() {
            axios
                .post("api/save-descripcion-pdf", this.descripcion_pdf)
                .then((res) => {
                    this.descripciones_pdf = res.data;
                    this.descripcion_pdf = {
                        id: null,
                        titulo: null,
                        descripcion: null,
                    };
                });
        },
        deleteDescripcionesPdf(id) {
            axios.get(`api/delete-descripcion-pdf/${id}`).then((res) => {
                this.descripciones_pdf = res.data;
            });
        },
        getSociedades() {
            axios.get("api/get-sociedades").then((res) => {
                this.sociedades = res.data;
            });
        },
        Validar() {
            axios
                .post("api/validate-contrato", { id: this.$route.query.id })
                .then((res) => {
                    this.$router.go();
                });
        },
        SearchCliente: debounce(function (val) {
            this.$store.dispatch("searchCliente", val);
        }, 500),
        endIntersect(entries, observer, isIntersecting) {
            if (isIntersecting) {
                this.$store.dispatch("getClientesNext", this);
            }
        },
        sendEmail() {
            axios
                .post(`api/sendEmailPresupuesto`, {
                    email: this.email,
                    id: this.presupuesto.id,
                    descripcion: this.email_descripcion,
                })
                .then((res) => {
                    this.email_dialog = false;
                    this.$custom_success("Correo enviado con éxito");
                });
        },
        openEmailDialog() {
            this.email_dialog = true;
        },
        closeEmailDialog() {
            this.email_dialog = false;
        },
        formatNumber(number) {
            return Number.parseFloat(number.toString())
                .toFixed(2)
                .replace(".", ",")
                .replace(",00", "");
        },
        CalcularTotalDcto(item) {
            return item.precio * item.cantidad - item.total;
        },
        getPresupuesto(id) {
            axios.get(`api/getpresupuesto/${id}`).then(
                (res) => {
                    this.presupuesto = res.data;
                    this.presupuesto.lineas_deleted = [];
                    let found = false;
                    this.presupuesto.iva = parseFloat(this.presupuesto.iva);
                    if (this.presupuesto.metodos_pago == null) {
                        this.presupuesto.metodos_pago = [];
                    }
                    if (this.presupuesto.cliente != null) {
                        if (this.presupuesto.cliente.length > 0) {
                            this.email = this.presupuesto.cliente[0].email;
                            found = true;
                            this.$store.dispatch("getClientesWithId", {
                                id: this.presupuesto.cliente[0].id_cliente,
                            });
                        }
                    }
                    if (!found) {
                        this.$store.dispatch("getClientes", this);
                    }
                    if (
                        Number.parseFloat(this.presupuesto.iva.toString()) != 0
                    ) {
                        this.enable_iva = true;
                    }
                },
                (res) => {}
            );
        },
        closeDialog() {
            this.delete_dialog = false;
            this.dialog = false;
        },
        openEditDialog(item) {
            this.dialog = true;
            this.editlinea = JSON.parse(JSON.stringify(item));
            this.init_edit = true;
            this.edit_index = this.presupuesto.lineas.indexOf(item);
        },
        Edit() {
            let items = JSON.parse(JSON.stringify(this.editlinea));
            let index1 = this.presupuesto.lineas[this.edit_index];
            index1.id_producto = items.id_producto;
            index1.producto = items.producto;
            index1.cantidad = items.cantidad;
            index1.precio = items.precio;
            index1.id_tipo_dcto = items.id_tipo_dcto;
            index1.dcto = items.dcto;
            index1.total = items.total;
            index1.tipo_prod = items.tipo_prod;
            index1.descripcion = items.descripcion;
            this.calcularTotal(index1);
            this.editlinea = {
                id_producto: null,
                producto: "",
                cantidad: 0,
                precio: 0,
                id_tipo_dcto: 0,
                dcto: 0,
                total: 0,
                tipo_prod: 0,
            };
            this.closeDialog();
            this.calcularTotalmax();
        },
        calcularSubTotal() {
            let total = 0;
            this.presupuesto.lineas.forEach((element) => {
                total += +element.total;
            });
            if (!isNaN(parseFloat(this.presupuesto.mudanza)))
                total += parseFloat(this.presupuesto.mudanza);
            return total;
        },
        calcularTotalmax() {
            this.presupuesto.total =
                (this.calcularSubTotal() - this.CalculateDescuento()) *
                (1 + this.presupuesto.iva / 100);
        },
        openDeleteDialog(item) {
            this.editlinea = item;
            this.delete_dialog = true;
        },
        deleteLinea() {
            let index = this.presupuesto.lineas.indexOf(this.editlinea);
            if (this.editlinea.id != null) {
                this.presupuesto.lineas_deleted.push(this.editlinea.id);
            }
            this.presupuesto.lineas.splice(index, 1);
            this.delete_dialog = false;
            this.calcularTotalmax();
        },
        openDescripcion() {
            if (!this.$refs.linea_form.validate()) return;
            const producto = this.productos.find(
                (element) => element.id == this.linea.id_producto
            );
            this.linea.descripcion = producto.descripcion;
            this.linea.titulo = producto.nombre;
            this.linea.denominacion = producto.nombre;

            this.product_dialog = true;
        },
        addLinea() {
            this.calcularTotal(this.linea);
            this.presupuesto.lineas.push(this.linea);

            this.emptyLinea();
            this.calcularTotalmax();
        },
        calcularTotal(linea) {
            linea.total = linea.precio * linea.cantidad;
            if (linea.id_tipo_dcto == 0) {
                linea.total *= 1 - linea.dcto / 100;
            } else if (linea.total > linea.dcto) {
                linea.total -= linea.dcto;
            } else {
                linea.total = 0;
            }
            linea.total = linea.total.toFixed(2);
        },
        emptyLinea() {
            this.linea = {
                id: null,
                id_producto: null,
                producto: "",
                cantidad: 0,
                precio: 0,
                id_tipo_dcto: 0,
                dcto: 0,
                total: 0,
                tipo_prod: 0,
            };
            this.$refs.linea_form.reset();
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },

        getClientes() {
            axios.get(`api/get-clientes/-1`).then(
                (res) => {
                    this.clientes = res.data.data;
                },
                (res) => {}
            );
        },
        getProductos() {
            axios.get(`api/get-productos`).then(
                (res) => {
                    this.productos = res.data.Productos;
                },
                (res) => {}
            );
        },
        getAgentes() {
            axios.get(`api/get-productos`).then(
                (res) => {
                    this.agentes = res.data.Agentes;
                },
                (res) => {}
            );
        },
        savePresupuesto() {
            if (!this.$refs.form.validate()) {
                this.$custom_error("Debe llenar los campos requeridos");
                return;
            }
            if (this.totalMetodoPago != 100) {
                this.$custom_error(
                    "La suma de los porcentajes en métodos de pago debe tener un total del 100%"
                );
                return;
            }
            this.presupuesto.id_sociedad = 6;
            axios
                .post("api/save-presupuesto", this.presupuesto)
                .then((res) => {
                    this.$router.push("lista-presupuesto");
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        deletePresupuesto() {
            axios
                .post("api/delete-presupuesto", { id: this.presupuesto.id })
                .then(
                    (res) => {
                        this.$toast.sucs("Presupuesto eliminado con éxito");
                        this.$router.push("lista-presupuesto");
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el presupuesto");
                    }
                );
            this.getPresupuestos();
        },
        PresupuestoToContrato() {
            axios
                .post("api/PresupuestoToContrato", { id: this.presupuesto.id })
                .then((res) => {
                    this.$router.push(`guardar-contrato?id=${res.data.id}`);
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        updatePresupuesto() {
            if (!this.$refs.form.validate()) {
                this.$custom_error("Debe llenar los campos requeridos");
                return;
            }
            axios
                .post("api/update-presupuesto", this.presupuesto)
                .then((res) => {
                    this.$router.push("lista-presupuesto");
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        CalculateDescuento() {
            if (this.presupuesto.id_tipo_dcto == 1) {
                return this.presupuesto.dcto;
            } else {
                return this.calcularSubTotal() * (this.presupuesto.dcto / 100);
            }
        },
        razonChiguire(numero) {
            let total = 0;

            this.presupuesto.metodos_pago.forEach((element) => {
                if (element.id_metodo != 3) {
                    total += parseFloat(element.monto);
                } else {
                    // total += parseFloat(element.monto) / 1.21;
                }
            });
            if (total == 0) return numero;
            return (parseFloat(numero) * total) / 100;
        },
    },
    filters: {},

    computed: {
        getImage() {
            if (this.imagen != null) {
                return URL.createObjectURL(this.imagen);
            } else {
                return `api/get-presupuesto-image/${this.$route.query.id}`;
            }
        },
        totalMetodosChiguire() {
            let total = 0;
            this.presupuesto.metodos_pago.forEach((element) => {
                if (element.id_metodo != 3) {
                    total +=
                        parseFloat(element.monto) /
                        (1 + this.presupuesto.iva / 100);
                } else {
                    total += parseFloat(element.monto);
                }
            });
            return total;
        },

        totalMetodoPago() {
            let total = 0;
            this.presupuesto.metodos_pago.forEach((element) => {
                total += parseFloat(element.monto);
            });
            return total;
        },
        isloading() {
            return this.$store.getters.getloading;
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
        clientes() {
            let clientes_temp = this.$store.getters.getclientes;

            return clientes_temp;
        },
    },
};
</script>
<style>
.rowtwo {
    display: flex;
    flex-direction: row;
}
.spacing {
    padding-top: 0 !important;
}
</style>
